@if (grupo) {
  <div class="cat-editor" [formGroup]="grupo">
    <div class="grid">
      <mat-form-field appearance="outline">
        <mat-label>Nombre categoría</mat-label>
        <input matInput formControlName="nombre" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Variante</mat-label>
        <input matInput formControlName="variante" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Prioridad</mat-label>
        <input matInput type="number" formControlName="prioridad" />
        <mat-hint>Orden cuando se solapan zonas. Requerido.</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Variante de plantilla (nombreTemplate)</mat-label>
        <input matInput formControlName="nombreTemplate" />
        <mat-hint>
          Sub-vista dentro del template (ej. "violencia de genero"). La usan los
          templates custom; en blanco = "normal".
        </mat-hint>
      </mat-form-field>
    </div>

    <!-- Plantilla de botonera de ESTA categoría (chooser visual; mueve el preview). -->
    <span class="chooser-lbl">Plantilla de botonera</span>
    <div
      class="chooser"
      [style.--brand]="clienteFormValue?.configuracion?.colorTema || '#FB972E'"
    >
      <div class="chooser-group">
        <div class="choices c4">
          <!-- Sin plantilla propia: hereda la del cliente (o la custom anclada al bundleId). -->
          <div
            class="choice"
            [class.on]="!grupo.get('inicioTemplate')?.value"
            (click)="setBotonera(null)"
          >
            <div class="mini m-heredado"><i class="dash"></i></div>
            <div class="ch-ttl">Usar la del cliente</div>
          </div>
          @for (o of botoneraOpciones; track o.id) {
            <div
              class="choice"
              [class.on]="grupo.get('inicioTemplate')?.value === o.id"
              (click)="setBotonera(o.id)"
            >
              <div class="mini" [ngClass]="'m-' + o.id">
                @switch (o.id) {
                  @case ("grid") {
                    <i class="bar b1"></i><i class="bar b2"></i
                    ><i class="bar b3"></i>
                  }
                  @case ("banner") {
                    <i class="bn"></i><i class="bar b2"></i
                    ><i class="bar b3"></i>
                  }
                  @case ("centrado") {
                    <i class="bn"></i><i class="big"></i>
                  }
                  @case ("hub") {
                    <i class="t1"></i><i class="t2"></i><i class="t3"></i
                    ><i class="t4"></i>
                  }
                }
              </div>
              <div class="ch-ttl">{{ o.label }}</div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="cat-split" [class.no-preview]="!mostrarPreview">
      <div class="cat-split-form">
        <!-- Botones de esta categoría -->
        <h3>Botones</h3>
        @for (
          g of botonesControls;
          track g.get("_tmpId")?.value;
          let i = $index
        ) {
          <div class="boton-item">
            <div class="boton-item-head">
              <strong>Botón {{ i + 1 }}</strong>
              @if (esExistente(g)) {
                <span class="badge-existente">Existente</span>
              }
              <button
                mat-icon-button
                color="warn"
                type="button"
                (click)="eliminarBoton(i)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            @if (esExistente(g)) {
              <!-- Botón referenciado: solo lectura; quitar acá solo saca la referencia. -->
              <div class="boton-resumen">
                @if (g.get("urlImagen")?.value) {
                  <img class="thumb" [src]="g.get('urlImagen')?.value" alt="" />
                } @else {
                  <span
                    class="swatch"
                    [style.background]="g.get('color')?.value || '#e7e2d8'"
                    >{{ g.get("texto")?.value }}</span
                  >
                }
                <div class="boton-resumen-datos">
                  <strong>
                    {{ g.get("nombre")?.value }}
                    {{
                      g.get("variante")?.value
                        ? "(" + g.get("variante")?.value + ")"
                        : ""
                    }}
                  </strong>
                  <span>{{ g.get("funcion")?.value }}</span>
                  <span class="nota">
                    Se usa por referencia: para modificarlo, editalo en
                    Botones.
                  </span>
                </div>
              </div>
            } @else {
              <!-- Elegir uno ya creado convierte este botón en una referencia (solo eso). -->
              <ng-select
                #selExistente
                class="select-existente"
                [items]="botonesExistentes"
                placeholder="Usar un botón ya creado (opcional)"
                [searchFn]="searchBoton"
                bindLabel="nombre"
                (change)="usarExistente(i, $event, selExistente)"
              >
                <ng-template ng-option-tmp let-item="item">
                  <span>
                    {{ item.nombre }}
                    {{ item.variante ? "(" + item.variante + ")" : "" }}
                  </span>
                </ng-template>
              </ng-select>
              <app-boton-form
                [group]="g"
                [botoneraId]="botoneraId"
                [cantidadPrincipales]="cantidadPrincipales"
              ></app-boton-form>
            }
          </div>
        }
        <button
          mat-stroked-button
          color="primary"
          type="button"
          (click)="agregarBoton()"
        >
          <mat-icon>add</mat-icon> Agregar botón
        </button>

        <!-- Armado: agrupar en principales / secundarios / otros -->
        <app-categoria-armado
          [botones]="botones"
          [idsPrincipales]="idsPrincipales"
          [idsSecundarios]="idsSecundarios"
          [idsOtros]="idsOtros"
        ></app-categoria-armado>

        <!-- Imágenes override de la categoría: tapan la base del cliente. -->
        @if (slotsCategoria.length) {
          <h3>Imágenes de la categoría (override)</h3>
          <p class="nota">
            Vacío = usa la imagen del cliente. Lo que cargues acá pisa la base
            solo para esta categoría.
          </p>
          @if (!nombreValido) {
            <p class="nota warn">
              Poné el nombre del cliente para habilitar las subidas.
            </p>
          }
          <div class="slots">
            @for (slot of slotsCategoria; track slot.control) {
              <div class="slot">
                <span class="slot-label">{{ slot.label }}</span>
                <span class="slot-hint">{{ slot.hint }}</span>
                <div class="slot-row">
                  @if (imagenes.get(slot.control)?.value) {
                    <img
                      class="thumb"
                      [src]="imagenes.get(slot.control)?.value"
                      alt=""
                    />
                  }
                  <button
                    mat-stroked-button
                    type="button"
                    [disabled]="loading || !nombreValido"
                    (click)="catInp.click()"
                  >
                    <mat-icon>upload</mat-icon> Subir
                  </button>
                  <input
                    #catInp
                    type="file"
                    accept="image/*"
                    hidden
                    (change)="setFileCategoria($event, slot.control)"
                  />
                </div>
              </div>
            }
          </div>
        }
      </div>

      <!-- Preview en vivo de la categoría -->
      @if (mostrarPreview) {
        <div class="cat-split-preview">
          <app-provisionador-preview
            [vm]="previewVm"
            [soloBotonera]="true"
          ></app-provisionador-preview>
        </div>
      }
    </div>
  </div>
}
